import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { addDoc, updateDoc } from "firebase/firestore";
import {
  contentsCollectionRef,
  getContentDoc,
  uploadImgContent,
} from "../utils/firestoreHelpers";
import { useState } from "react";
import { formatDate } from "../utils/helpers";
import { businessTypes } from "../utils/constants";

const initialData = {
  title: "",
  type: "",
  link: "",
  date: "",
  description: "",
  venue: "",
  tnc: "",
  showIsInterested: "no",
};

const initialErrorData = {
  title: "",
  type: "",
  date: "",
  description: "",
  venue: "",
  tnc: "",
  showIsInterested: "",
  img: "",
};
const EditBusiness = ({
  onClose,
  prevData,
  newType = "",
  dialogType,
  setdialogType,
}) => {
  const [img, setImg] = useState(null);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(
    prevData
      ? {
          ...prevData,
          date: formatDate(prevData.date),
          showIsInterested: prevData.showIsInterested ? "yes" : "no",
        }
      : { ...initialData, type: newType }
  );
  const [error, setError] = useState({ ...initialErrorData });

  const validate = () => {
    const {
      title = "",
      link = "",
      type = "",
      date = "",
      description = "",
      venue = "",
      tnc = "",
      showIsInterested = "",
    } = data || {};

    let isValid = true;
    let tempError = { ...initialErrorData };

    const cleanTitle = title.trim();
    const cleanType = type.trim();
    const cleanLink = link.trim();
    const cleanDesc = description.trim();
    const cleanVenue = venue.trim();
    const cleanTnc = tnc.trim();

    //  Title
    if (!cleanTitle) {
      isValid = false;
      tempError.title = "Title is required";
    } else if (cleanTitle.length < 3 || cleanTitle.length > 200) {
      isValid = false;
      tempError.title = "Title must be between 3 and 200 characters";
    }

    //  Link
    if (!cleanLink) {
      isValid = false;
      tempError.link = "Link is required";
    } else if (!/^https?:\/\/.+\..+/.test(cleanLink)) {
      isValid = false;
      tempError.link = "Enter a valid URL";
    }

    // Type
    if (!cleanType) {
      isValid = false;
      tempError.type = "Type is required";
    } else if (cleanType.length < 3 || cleanType.length > 200) {
      isValid = false;
      tempError.type = "Type must be between 3 and 200 characters";
    }

    // Date
    if (!date) {
      isValid = false;
      tempError.date = "Date is required";
    }

    //  Show Interested
    if (!["yes", "no"].includes(showIsInterested)) {
      isValid = false;
      tempError.showIsInterested = "Please select a valid value";
    }

    //  Image
    if (!img && !prevData?.image_url) {
      isValid = false;
      tempError.img = "Image is required";
    } else if (img) {
      const validTypes = ["image/png", "image/jpeg", "image/jpg"];
      if (!validTypes.includes(img.type)) {
        isValid = false;
        tempError.img = "Only PNG, JPG, JPEG images are allowed";
      }
    }

    //  Optional fields
    if (cleanDesc && (cleanDesc.length < 3 || cleanDesc.length > 500)) {
      isValid = false;
      tempError.description =
        "Description must be between 3 and 500 characters";
    }

    if (cleanVenue && (cleanVenue.length < 3 || cleanVenue.length > 500)) {
      isValid = false;
      tempError.venue = "Venue must be between 3 and 500 characters";
    }

    if (cleanTnc && (cleanTnc.length < 3 || cleanTnc.length > 500)) {
      isValid = false;
      tempError.tnc = "Terms must be between 3 and 500 characters";
    }

    setError(tempError);
    return isValid;
  };

  const onSubmit = async () => {
    // console.log("data :: ", data);
    // return;
    let isValid = validate();
    if (!isValid) return;
    setLoading(true);
    const {
      title,
      type,
      date,
      description,
      venue,
      tnc,
      showIsInterested,
      link,
    } = data;
    if (prevData) {
      let image_url = prevData.image_url;
      const bussinessDoc = getContentDoc(prevData.id);
      if (img) {
        image_url = await uploadImgContent(img);
      }
      const newFields = {
        image_url,
        title,
        link: link || "",
        type,
        date: new Date(date),
        description,
        venue,
        tnc,
        showIsInterested: showIsInterested === "yes",
      };
      await updateDoc(bussinessDoc, newFields);
    } else {
      if (!img) return;
      const image_url = await uploadImgContent(img);
      const payload = {
        image_url,
        title,
        link,
        type,
        date: new Date(date),
        description,
        venue,
        tnc,
        showIsInterested: showIsInterested === "yes",
      };
      if (showIsInterested) {
        payload["interested"] = [];
        payload["not_interested"] = [];
      }
      await addDoc(contentsCollectionRef, payload);
    }
    setLoading(false);
    onClose();
  };

  const onChange = (e) => {
    let value = e.target.value;
    const name = e.target.name;

    setData((prev) => {
      let temp = prev;
      if (name === "type" && value === "news") {
        temp = { ...prev, showIsInterested: "no" };
      }
      temp = { ...prev, [name]: value };
      return temp;
    });
  };

  const [fileSizeError, setFileSizeError] = useState("");
  const fileSizeLimit = 1 * 1024 * 1024; // 1 MB limit

  const checkFileSize = (event) => {
    const fileInput = event.target;

    if (fileInput.files.length > 0 && fileInput.files[0].size > fileSizeLimit) {
      setFileSizeError("File size exceeds the 1 mb limit.");
      fileInput.value = ""; // Clear the input
    } else {
      setImg(event.target.files[0]);
      setFileSizeError("");
    }
  };

  return (
    <form>
      <Modal show={true} onHide={() => {}}>
        <Modal.Header>
          <Modal.Title>{`${dialogType} Business Content`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label htmlFor="title" className="form-label d-block">
              Title *
            </label>
            <input
              value={data.title}
              onChange={onChange}
              className="w-100 form-control"
              name="title"
              required
            />
            <p className="text-danger small">{error.title}</p>
          </div>
          <div className="mb-3">
            <label htmlFor="link" className="form-label d-block">
              Link
            </label>
            <input
              value={data.link}
              onChange={onChange}
              className="w-100 form-control"
              name="link"
            />
            <p className="text-danger small">{error.link}</p>
          </div>
          <div className="d-flex gap-1">
            <div className="mb-3 flex-fill">
              <label htmlFor="type" className="form-label d-block">
                Type *
              </label>
              <select
                value={data.type}
                onChange={onChange}
                className="w-100 form-control"
                name="type"
                required
              >
                <option value=""> </option>
                {businessTypes.map(({ label, value }) => (
                  <option value={value} key={value}>
                    {label}
                  </option>
                ))}
              </select>
              <p className="text-danger small">{error.type}</p>
            </div>
            <div className="mb-3 flex-fill" flex-fill>
              <label htmlFor="date" className="form-label d-block">
                Date *
              </label>
              <input
                type="date"
                className="w-100 form-control"
                name="date"
                value={data.date}
                onChange={onChange}
                required
              />
              <p className="text-danger small">{error.date}</p>
            </div>
          </div>
          <div className="mb-3">
            <label htmlFor="showIsInterested" className="form-label d-block">
              Show Is Interested Buttons *
            </label>{" "}
            <div className="d-flex gap-4">
              <div class="form-check">
                <input
                  disabled={data.type === "news"}
                  class="form-check-input"
                  type="checkbox"
                  name="showIsInterested"
                  value={"yes"}
                  id="yes-is-interested"
                  onChange={onChange}
                  checked={data.showIsInterested === "yes"}
                />
                <label class="form-check-label" htmlFor="yes-is-interested">
                  Yes
                </label>
              </div>
              <div class="form-check">
                <input
                  disabled={data.type === "news"}
                  class="form-check-input"
                  type="checkbox"
                  value="no"
                  name="showIsInterested"
                  id="no-is-interested"
                  onChange={onChange}
                  checked={data.showIsInterested === "no"}
                />
                <label class="form-check-label" htmlFor="no-is-interested">
                  No
                </label>
              </div>
            </div>
            <p className="text-danger small">{error.showIsInterested}</p>
          </div>

          <div className="mb-3">
            <label htmlFor="image" className="form-label d-block">
              Image *
            </label>
            <input
              type="file"
              className="w-100 form-control"
              name="image"
              // onChange={(e) => setImg(e.target.files[0])}
              onChange={checkFileSize}
              required
              accept="image/png, image/jpeg, image/jpg"
            />
            <p className="text-danger small mt-1">{fileSizeError}</p>
            <p className="text-danger small">{error.img}</p>
          </div>
          {(data?.image_url || img) && (
            <div className="mb-3">
              <img
                src={img ? URL.createObjectURL(img) : data?.image_url}
                height={150}
                width={200}
                alt="preview"
              />
            </div>
          )}
          <div className="mb-3">
            <label htmlFor="description" className="form-label d-block">
              Description
            </label>
            <textarea
              value={data.description}
              className="w-100 form-control"
              name="description"
              onChange={onChange}
            />
             <p className="text-danger small">{error.description}</p>
          </div>
          <div className="mb-3">
            <label htmlFor="venue" className="form-label d-block">
              Venue
            </label>
            <textarea
              value={data.venue}
              className="w-100 form-control"
              name="venue"
              onChange={onChange}
            />
             <p className="text-danger small">{error.venue}</p>
          </div>
          <div className="mb-3">
            <label htmlFor="tnc" className="form-label d-block">
              Terms and condition
            </label>
            <textarea
              value={data.tnc}
              className="w-100 form-control"
              name="tnc"
              onChange={onChange}
            />
             <p className="text-danger small">{error.tnc}</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
          <Button variant="primary" onClick={onSubmit} disabled={loading}>
            {loading ? (
              <>
                <span
                  class="spinner-grow spinner-grow-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Loading...
              </>
            ) : (
              "Save"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </form>
  );
};

export default EditBusiness;
